import React, { useState, useContext, useEffect } from "react";
import { CatTagContext } from "../contexts/CatTagContext";
import { AutoCatContext } from "../contexts/AutoCatContext";
import { MemoContext } from "../contexts/MemoContext";
import { Drawer, Select, Divider, Input, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import TagItem from "./TagItem";
// import MemoEditor from "./MemoEditor";
import TinyEditor from "../components/TinyEditor";
import Record from "./Record";

import axios from "axios";
import ScanDoc from "./ScanDoc";
const antIcon = (
  <LoadingOutlined style={{ fontSize: 22, color: "white" }} spin />
);

const { Option } = Select;

const AddMemo = () => {
  const { autoCat, sugTag, sugCat, load } = useContext(AutoCatContext);
  const { categories, tags, fetchCatTag } = useContext(CatTagContext);
  const { fetchMemo } = useContext(MemoContext);
  const [catItems, setCatItems] = useState([]);
  const [tagItems, setTagItems] = useState([]);
  const [tagValue, setTagValue] = useState([]);
  const [catValue, setCatValue] = useState([]);
  const [userCat, setUserCat] = useState([]);
  const [userTag, setUserTag] = useState([]);
  const [addLoad, setAddLoad] = useState(false);
  // const [memo, setMemo] = useState(
  //   JSON.parse(localStorage.getItem("content")) || [
  //     {
  //       type: "paragraph",
  //       children: [{ text: "" }],
  //     },
  //   ]
  // );
  const [memo, setMemo] = useState("");
  const [memoPlain, setMemoPlain] = useState("");
  useEffect(() => {
    setTagValue(sugTag);
  }, [sugTag]);

  useEffect(() => {
    setCatValue(sugCat);
  }, [sugCat]);

  useEffect(() => {
    if (categories.length !== 0) {
      const cat = categories.map((e) => e.category);
      setUserCat(cat);
    }
  }, [categories]);

  useEffect(() => {
    if (tags.length !== 0) {
      const tag = tags.map((e) => <Option key={e.tag}>{e.tag}</Option>);
      setUserTag(tag);
    }
  }, [tags]);

  useEffect(() => {
    if (userCat.length !== 0) {
      setCatItems([...userCat]);
    }
  }, [userCat]);

  useEffect(() => {
    if (userTag.length !== 0) {
      setTagItems([...userTag]);
    }
  }, [userTag]);

  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  const handleChange = (value) => {
    let check = true;
    value.forEach((e) => {
      if (e.includes("\\")) {
        check = false;
      }
    });
    if (check) {
      setTagValue(value);
    }
  };

  const [newCat, setNewCat] = useState("");

  const onNewCatChange = (event) => {
    setNewCat(event.target.value);
  };

  const addItem = () => {
    let checkDup = true;
    catItems.forEach((e) => {
      if (e === newCat) {
        checkDup = false;
      }
    });
    if (checkDup === true) {
      setCatItems([...catItems, newCat]);
      setNewCat("");
    }
  };

  const keepMemo = () => {
    setAddLoad(true);
    let formData = {
      // editor: JSON.stringify(memo),
      editor: memo,
      content: memoPlain,
      category_id: null,
      newCat: null,
      tag_id: [],
      newTag: [],
    };

    if (catValue.length > 0) {
      categories.forEach((e) => {
        if (e.category === catValue.replace(/"/g, "'").replace(/'/g, "\\'")) {
          formData.category_id = e.cid;
        }
      });
      if (!formData.category_id) {
        if (catValue.length !== 0) {
          formData.newCat = catValue.replace(/"/g, "'").replace(/'/g, "\\'");
        }
      }
    }

    tagValue.forEach((a) => {
      let check = false;
      tags.forEach((b) => {
        if (
          a.replace(/\\/g, "/").replace(/"/g, "'").replace(/'/g, "\\'") ===
          b.tag
        ) {
          formData.tag_id.push(b.tid);
          check = true;
        }
      });
      if (check === false) {
        formData.newTag.push(a.replace(/"/g, "'").replace(/'/g, "\\'"));
      }
    });

    axios
      .post("/addMemo", formData)
      .then(() => {
        fetchCatTag();
        fetchMemo();
        setTimeout(() => {
          setAddLoad(false);
          onClose();
          setTagValue([]);
          setCatValue([]);
          setMemo("");
          // setMemo([
          //   {
          //     type: "paragraph",
          //     children: [{ text: "" }],
          //   },
          // ]);
          // localStorage.setItem(
          //   "content",
          //   JSON.stringify([
          //     {
          //       type: "paragraph",
          //       children: [{ text: "" }],
          //     },
          //   ])
          // );
        }, 500);
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div
        onClick={showDrawer}
        className="hidden lg:flex flex-initial justify-center items-center cursor-pointer mx-4"
      >
        <div className="flex flew-row items-center justify-center m-0 p-4 rounded-lg text-center text-white bg-blue-400 hover:bg-blue-500">
          <svg
            className="w-6 h-6 mr-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z"
            />
          </svg>
          <p className="m-0 p-0 font-bold">NEW MEMO</p>
        </div>
      </div>
      <Drawer
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        width={"60%"}
      >
        <div className="w-full h-full flex flex-col">
          {/* <p className="p-0 m-0 text-4xl font-bold text-blue-400">
            Create new Memo
          </p> */}
          <div className="h-full tiny">
            {/* <MemoEditor value={memo} setValue={setMemo} isAdd={true} /> */}
            <TinyEditor
              value={memo}
              setValue={setMemo}
              setPlain={setMemoPlain}
            />
            {/* TODO : DAMN */}
          </div>
          <div className="mt-8">
            <Select
              tagRender={TagItem}
              bordered={false}
              size="large"
              mode="tags"
              style={{ width: "100%" }}
              placeholder="Write all your memo tag here.."
              onChange={handleChange}
              value={tagValue}
            >
              {tagItems}
            </Select>
          </div>
          <div className="flex-initial mb-5 flex justify-between items-center">
            <Select
              value={catValue}
              onChange={(v) => {
                setCatValue(v);
              }}
              bordered={false}
              size="large"
              style={{ color: "#4a5568", minWidth: "40%" }}
              placeholder="Choose a category"
              dropdownRender={(menu) => (
                <div>
                  {menu}
                  <Divider style={{ margin: "4px 0" }} />
                  <div className="flex items-center p-2">
                    <Input
                      style={{ flex: "auto" }}
                      value={newCat}
                      onChange={onNewCatChange}
                    />
                    <p
                      onClick={addItem}
                      className="py-1 px-2 m-0 ml-2 bg-blue-400 text-white rounded-sm cursor-pointer"
                    >
                      ADD
                    </p>
                  </div>
                </div>
              )}
            >
              {catItems.map((item) => (
                <Option key={item}>{item}</Option>
              ))}
            </Select>
            <div className="flex">
              <Record memo={memo} setMemo={setMemo} />
              <ScanDoc memo={memo} setMemo={setMemo} />
              <div
                onClick={() => {
                  if (!(load[0] && load[1])) {
                    autoCat(memoPlain);
                  }
                }}
                className="m-0 mr-3 p-3 w-24 text-center font-bold bg-blue-400 text-white rounded-md cursor-pointer hover:bg-blue-500"
              >
                {load[0] && load[1] ? (
                  <Spin indicator={antIcon} />
                ) : (
                  <span>MEMMIFY</span>
                )}
              </div>
              <div
                onClick={() => {
                  if (!addLoad) {
                    keepMemo();
                  }
                }}
                className="m-0 p-3 text-center w-16 font-bold bg-gray-700 text-white rounded-md cursor-pointer hover:bg-gray-800"
              >
                {addLoad ? <Spin indicator={antIcon} /> : <span>KEEP</span>}
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default AddMemo;
